import { domAnimation, LazyMotion, m } from 'framer-motion';
import type { CSSProperties } from 'react';
import type { IDimOverlayProps } from './DimOverlay.interface';
import {
    animationStateForElement,
    animationVariantsForElement,
    classNameForElement,
    StyleElem,
    styleForElement,
} from './DimOverlay.style';

function DimOverlay(props: IDimOverlayProps): JSX.Element {
    const style = (elem: StyleElem, overrides: CSSProperties = {}) =>
        styleForElement(elem, props, overrides);
    const className = (elem: StyleElem) => classNameForElement(elem, props);

    const onClick = () => props.onClick?.(props.isDim);

    return (
        <LazyMotion strict features={domAnimation}>
            <m.button
                onClick={onClick}
                animate={animationStateForElement(StyleElem.Container, props)}
                variants={animationVariantsForElement(StyleElem.Container)}
                className={`${className(StyleElem.Container)} ${props.className ?? ''}`}
                style={style(StyleElem.Container, props.style)}
            >
                {props.children}
            </m.button>
        </LazyMotion>
    );
}

export default DimOverlay;
